// extracted by mini-css-extract-plugin
export default {"image":"PopularItemImage-module__image___2yQSF","star":"PopularItemImage-module__star___3glGJ"};